import React from "react";
import PropTypes from "prop-types";
import { MDBBtn } from "mdbreact";

const LINK_INTERESSE =
	"https://feevale.apprbs.com.br/graduacao-interesse";

const LINK_EAD =
	"https://ingresso.feevale.br/?idcategoriaps=24";

const LINK_PRE_SEMI =
	"https://ingresso.feevale.br/?idcategoriaps=17,29";

const LINK_MEDICINA =
	"https://ingresso.feevale.br/medicina/login";

const LINK_PROFESSOR_AMANHA =
	"https://feevale.apprbs.com.br/professor-do-amanha/";

export default function BotaoIngressoCurso({
	modalidade,
	isMedicina = false,
	cursoEspecial = false,
	className = "",
}) {
	let href = null;
	let texto = null;
	let usaAnimacao = false;

	if (cursoEspecial) {
		href = LINK_PROFESSOR_AMANHA;
		texto = "Professor do Amanhã";
		usaAnimacao = true;
	} else if (isMedicina) {
		href = LINK_MEDICINA;
		texto = "Portal do Inscrito";
		usaAnimacao = true;
	} else if (modalidade === "EAD") {
		href = LINK_EAD;
		texto = "INSCREVA-SE";
		usaAnimacao = true;
	} else if (
		modalidade === "Hibrido" ||
		modalidade === "Semipresencial" ||
		modalidade === "Presencial"
	) {
		href = LINK_PRE_SEMI;
		texto = "INSCREVA-SE";
		usaAnimacao = true;
	}

	if (!href || !texto) return null;

	const classes = [
		"saira-title",
		"curso-acao-full",
		usaAnimacao ? "animated-button-top" : "",
		className,
	]
		.filter(Boolean)
		.join(" ");

	return (
		<a
			href={href}
			target="_blank"
			rel="noopener noreferrer"
			className="curso-acao-full-link"
		>
			<MDBBtn
				className={classes}
				style={{
					margin: "0",
					marginBottom: "10px",
					width: "100%",
				}}
				color="primary"
			>
				{texto}
			</MDBBtn>
		</a>
	);
}

BotaoIngressoCurso.propTypes = {
	modalidade: PropTypes.string,
	isMedicina: PropTypes.bool,
	cursoEspecial: PropTypes.bool,
	className: PropTypes.string,
};
